/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityAssetTechResult } from './MonitEntityAssetTechResult';
import {
    MonitEntityAssetTechResultFromJSON,
    MonitEntityAssetTechResultFromJSONTyped,
    MonitEntityAssetTechResultToJSON,
} from './MonitEntityAssetTechResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityAssetTechResponse
 */
export interface MonitPaginatedEntityAssetTechResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityAssetTechResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityAssetTechResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityAssetTechResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityAssetTechResult>}
     * @memberof MonitPaginatedEntityAssetTechResponse
     */
    results?: Array<MonitEntityAssetTechResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityAssetTechResponse interface.
 */
export function instanceOfMonitPaginatedEntityAssetTechResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityAssetTechResponseFromJSON(json: any): MonitPaginatedEntityAssetTechResponse {
    return MonitPaginatedEntityAssetTechResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityAssetTechResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityAssetTechResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityAssetTechResultFromJSON)),
    };
}

export function MonitPaginatedEntityAssetTechResponseToJSON(value?: MonitPaginatedEntityAssetTechResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityAssetTechResultToJSON)),
    };
}

